(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-new"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener("DOMContentLoaded", function () {

  const footerCols = document.querySelectorAll(".footer__col");

  footerCols.forEach((col) => {

    const title = col.querySelector(".footer__col-title");
    const list = col.querySelector(".footer__col-list");

    if (!title || !list) return;

    title.addEventListener("click", function () {

      // Mobile only
      if (window.innerWidth <= 767) {

        list.classList.toggle("active");

        // optional for plus/cross icon
        title.classList.toggle("active");
      }

    });

  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
